export const urlApi = 'https://thinkito.coderf5.es';
export const urlFont = 'https://juancmacias.github.io/alma-thinking-with-you/public/font';
export const urlVid = 'https://juancmacias.github.io/alma-thinking-with-you/';


